import request from '@/utils/request';
import { AxiosPromise } from 'axios';
import { EnlistsInfoVO, EnlistsInfoForm, EnlistsInfoQuery } from '@/api/opus/enlistsInfo/types';

/**
 * 访问量增加
 * @param query
 * @returns {*}
 */

export const addPageView = () => {
  return request({
    url: '/opus/websiteVisits/save',
    method: 'post'
  });
};

/**
 * 数据统计接口
 * @param data
 */
export const platformVisitsStatistics = (query) => {
  return request({
    url: '/opus/websiteVisits/websiteVisitsDimensionCount',
    method: 'get',
    params: query
  });
};
